import React, { useState } from 'react';
import api from '../api/axios';
import Layout from '../components/Layout';

const Uploads = () => {
  const [deliveryFile, setDeliveryFile] = useState(null);
  const [routeFile, setRouteFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const handleUpload = async (type) => {
    const file = type === 'deliveries' ? deliveryFile : routeFile;
    
    if (!file) {
      alert('נא לבחור קובץ');
      return;
    }

    setUploading(true);
    setUploadResult(null);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await api.post(`/uploads/${type}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      setUploadResult({
        success: true,
        message: response.data.message,
        summary: response.data.summary
      });
      
      if (type === 'deliveries') setDeliveryFile(null);
      else setRouteFile(null);
    } catch (error) {
      console.error('Upload error:', error);
      console.error('Error response:', error.response?.data);
      setUploadResult({
        success: false,
        message: error.response?.data?.error || 'שגיאה בהעלאת קובץ',
        details: error.response?.data?.details || error.message,
        summary: error.response?.data?.summary
      });
    } finally {
      setUploading(false);
    }
  };

  const UploadZone = ({ title, file, setFile, type }) => (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-bold text-nexolog-navy mb-4">{title}</h2>
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-nexolog-teal transition-colors">
        <input
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={(e) => setFile(e.target.files[0])}
          className="hidden"
          id={type}
        />
        <label
          htmlFor={type}
          className="cursor-pointer flex flex-col items-center gap-4"
        >
          <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          <div>
            <p className="text-lg font-medium text-gray-700">גרור קובץ או לחץ להעלאה</p>
            <p className="text-sm text-gray-500 mt-1">CSV, XLSX, XLS</p>
          </div>
        </label>
      </div>
      {file && (
        <div className="mt-4">
          <p className="text-sm text-gray-700">קובץ נבחר: <span className="font-medium">{file.name}</span></p>
          <button
            onClick={() => handleUpload(type)}
            disabled={uploading}
            className="mt-4 w-full bg-nexolog-teal hover:bg-nexolog-teal/90 text-white font-medium py-3 rounded-lg transition-colors disabled:opacity-50"
          >
            {uploading ? 'מעלה...' : 'העלה קובץ'}
          </button>
        </div>
      )}
    </div>
  );

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold text-nexolog-navy">העלאת קבצים</h1>

        {uploadResult && (
          <div className={`rounded-lg p-6 ${uploadResult.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
            <h3 className={`text-lg font-bold mb-2 ${uploadResult.success ? 'text-green-800' : 'text-red-800'}`}>
              {uploadResult.success ? '✅ ' : '❌ '}{uploadResult.message}
            </h3>
            
            {uploadResult.details && (
              <p className="text-sm text-red-700 mb-2">{uploadResult.details}</p>
            )}
            
            {uploadResult.summary && (
              <div className="mt-4 space-y-2 text-sm">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div>
                    <span className="font-medium">סה"כ שורות:</span> {uploadResult.summary.totalRows}
                  </div>
                  <div>
                    <span className="font-medium">שורות תקינות:</span> <span className="text-green-600">{uploadResult.summary.validRows}</span>
                  </div>
                  <div>
                    <span className="font-medium">שורות עם שגיאות:</span> <span className="text-red-600">{uploadResult.summary.errorRows}</span>
                  </div>
                  <div>
                    <span className="font-medium">נהגים שנוצרו:</span> <span className="text-blue-600">{uploadResult.summary.createdDrivers}</span>
                  </div>
                </div>

                {uploadResult.summary.createdDriversList && uploadResult.summary.createdDriversList.length > 0 && (
                  <div className="mt-4 p-3 bg-blue-50 rounded border border-blue-200">
                    <p className="font-medium text-blue-800 mb-2">נהגים שנוצרו אוטומטית:</p>
                    <ul className="list-disc list-inside space-y-1 text-blue-700">
                      {uploadResult.summary.createdDriversList.map((driver, idx) => (
                        <li key={idx}>{driver.name} - {driver.note}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {uploadResult.summary.errors && uploadResult.summary.errors.length > 0 && (
                  <div className="mt-4 p-3 bg-red-50 rounded border border-red-200">
                    <p className="font-medium text-red-800 mb-2">שורות עם שגיאות:</p>
                    <div className="max-h-60 overflow-y-auto space-y-2">
                      {uploadResult.summary.errors.map((error, idx) => (
                        <div key={idx} className="text-sm bg-white p-2 rounded border border-red-200">
                          <p className="font-medium text-red-700">שורה {error.line}:</p>
                          <p className="text-gray-700">{error.delivery_id || error.route_name || 'לא זוהה'}</p>
                          <ul className="list-disc list-inside mt-1 text-red-600">
                            {error.errors.map((err, errIdx) => (
                              <li key={errIdx}>{err}</li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <UploadZone
            title="דוח משלוחים"
            file={deliveryFile}
            setFile={setDeliveryFile}
            type="deliveries"
          />
          <UploadZone
            title="דוח מסלולים"
            file={routeFile}
            setFile={setRouteFile}
            type="routes"
          />
        </div>
      </div>
    </Layout>
  );
};

export default Uploads;

